import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates Golf specific combo prevention. Golf V2 is not compatible for combo with Golf V1.
 * Generally it should be a check for same sport check when one is V1 and the other is V2.
 */
export class V2GolfComboPrevention extends BaseComboPrevention<BetslipV2Pick, BetslipV1Pick> {
    constructor() {
        super(BetslipV2Pick, BetslipV1Pick);
    }

    validate(thisPick: BetslipV2Pick, otherPick: BetslipV1Pick, isSystemBet: boolean): ComboPreventionResult {
        if (thisPick.fixture.sportId === SportConstant.Golf && otherPick.sport.id === SportConstant.Golf) {
            return ComboPreventionResult.GolfV2WithGolfV1;
        }

        return ComboPreventionResult.AllCombo;
    }

    override canValidate(thisPick: BetslipV2Pick, otherPick: BetslipV1Pick, ignoreGroupInfo: boolean = false): boolean {
        return super.canValidate(thisPick, otherPick, ignoreGroupInfo) && thisPick.fixture.sportId === SportConstant.Golf;
    }
}
